import { useTranslation } from "react-i18next";
import { Button } from "./button";

/** Offset pager for admin tables: "1–25 of 140" with Previous/Next. `offset` is zero-based. */
export function Pager({
  offset,
  limit,
  total,
  shown,
  onOffsetChange,
}: {
  offset: number;
  limit: number;
  total: number;
  /** How many rows the current page actually has. */
  shown: number;
  onOffsetChange: (offset: number) => void;
}) {
  const { t } = useTranslation();
  const first = total === 0 ? 0 : offset + 1;
  const last = offset + shown;
  return (
    <nav
      aria-label={t("common.pagination")}
      className="flex items-center justify-between gap-2 text-sm"
    >
      <p role="status" className="text-muted">
        {t("common.pageRange", { first, last, total })}
      </p>
      <div className="flex gap-2">
        <Button
          size="sm"
          variant="secondary"
          disabled={offset <= 0}
          onClick={() => onOffsetChange(Math.max(0, offset - limit))}
        >
          {t("common.previous")}
        </Button>
        <Button
          size="sm"
          variant="secondary"
          disabled={offset + limit >= total}
          onClick={() => onOffsetChange(offset + limit)}
        >
          {t("common.next")}
        </Button>
      </div>
    </nav>
  );
}
